<template>
  <div class="data-manage">
    <star-condition-layout
      :onSearch="handleSearch"
      :onReset="reset"
      :loading="loading"
      ref="condition"
    >
      <star-condition-cell label="站点类型">
        <a-select v-model="search.siteType" style="width: 100%">
          <a-select-option value="全部"> 全部</a-select-option>
          <a-select-option v-for="item in spiderClassOptions" :key="item.type" :value="item.type"
            >{{ item.spiderClassName }}
          </a-select-option>
        </a-select>
      </star-condition-cell>
      <star-condition-cell label="重要程度">
        <a-select v-model="search.degreeImport" style="width: 100%">
          <!-- 非常重要、重要、一般、未知 全部 -->
          <a-select-option value="全部"> 全部</a-select-option>
          <a-select-option :value="1"> 一般</a-select-option>
          <a-select-option :value="2"> 重要</a-select-option>
          <a-select-option :value="3">非常重要 </a-select-option>
          <a-select-option :value="0">未知 </a-select-option>
        </a-select>
      </star-condition-cell>
      <star-condition-cell label="当前状态">
        <a-select v-model="search.currentStatus" style="width: 100%">
          <!-- 正常、异常、停止监控、等待验证 -->
          <a-select-option value="全部"> 全部</a-select-option>
          <a-select-option :value="0"> 正常</a-select-option>
          <a-select-option :value="1"> 异常</a-select-option>
          <!-- <a-select-option :value="2">停止监控 </a-select-option> -->
          <a-select-option :value="3">等待验证 </a-select-option>
        </a-select>
      </star-condition-cell>
      <star-condition-cell label="监控状态">
        <a-select v-model="search.monitorStatus" style="width: 100%">
          <!-- 正常、异常、停止监控、等待验证 -->
          <a-select-option value="全部"> 全部</a-select-option>
          <a-select-option :value="0"> 正常</a-select-option>
          <!-- <a-select-option :value="1"> 异常</a-select-option> -->
          <a-select-option :value="1">停止监控 </a-select-option>
          <!-- <a-select-option :value="3">等待验证 </a-select-option> -->
        </a-select>
      </star-condition-cell>
      <star-condition-cell label="分配状态">
        <a-select v-model="search.allotStatus" style="width: 100%">
          <a-select-option value="全部"> 全部</a-select-option>
          <a-select-option :value="0"> 待分配</a-select-option>
          <a-select-option :value="1"> 已分配</a-select-option>
        </a-select>
      </star-condition-cell>
      <star-condition-cell label="负责团队">
        <a-select v-model="search.groupId" style="width: 100%" @select="selectValue">
          <a-select-option value="全部"> 全部</a-select-option>
          <a-select-option v-for="(item, index) in dataGroup" :key="index" :value="item.id">
            {{ item.groupName }}</a-select-option
          >
        </a-select>
      </star-condition-cell>
      <star-condition-cell label="负责人员">
        <a-select allowClear v-model="search.groupMemberId" style="width: 100%">
          <!-- <a-select-option value="人员1"> 人员1</a-select-option>
          <a-select-option value="人员2"> 人员2</a-select-option> -->
          <a-select-option v-for="(item, index) in peopleGroup" :key="index" :value="item.id">
            {{ item.userDto.userName }}</a-select-option
          >
        </a-select>
      </star-condition-cell>
      <star-condition-cell label="站点名称">
        <a-input v-model="search.siteName" placeholder="请输入站点名称" />
      </star-condition-cell>
      <star-condition-cell label="站点id">
        <a-input v-model="search.siteId" placeholder="请输入站点id" />
      </star-condition-cell>
    </star-condition-layout>

    <div class="table-wrap">
      <TableHeadIcons :onRefresh="getTableList" :size.sync="tableDensity" :columns="columns">
        <a-button type="primary" @click="handleGroup">团队分配</a-button>
        <a-button type="primary" @click="handleGroupPzS">批量监控配置</a-button>
      </TableHeadIcons>

      <a-table
        :loading="loading"
        :size="tableDensity"
        :pagination="pagination"
        @change="handleTableChange"
        :columns="showColumns"
        :dataSource="dataSource"
        :row-key="(record) => record.id"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      >
        <span slot="index" slot-scope="text, record, index">{{ index + 1 }}</span>
        <span slot="siteId" slot-scope="text">
          <a-tooltip>
            <template slot="title"> {{ text }} </template>
            <span>
              {{ text }}
            </span>
          </a-tooltip>

          <a-tooltip>
            <template slot="title"> 复制 </template>
            <a
              href="javascript:;"
              v-clipboard:copy="text"
              v-clipboard:success="onCopy"
              v-clipboard:error="onCopyError"
            >
              <a-icon type="copy" />
            </a>
          </a-tooltip>
        </span>
        <span slot="siteName" slot-scope="text, record">
          <a-tooltip>
            <template slot="title"> {{ text }} </template>
            <a @click="openWindow(record)">
              {{ returnSiteName(text) }}
            </a>
          </a-tooltip>

          <a-tooltip>
            <template slot="title"> 复制 </template>
            <a
              href="javascript:;"
              v-clipboard:copy="text"
              v-clipboard:success="onCopy"
              v-clipboard:error="onCopyError"
            >
              <a-icon type="copy" />
            </a>
          </a-tooltip>
        </span>
        <!-- siteName -->
        <span slot="siteType" slot-scope="text, record">{{ returnSiteType(record.siteType) }}</span>
        <span slot="degreeImport" slot-scope="text, record">{{
          returnDegreeImport(record.degreeImport)
        }}</span>
        <span slot="currentStatus" slot-scope="text, record">
          <div style="display: flex" v-if="record.currentStatus == 0">
            <div
              style="
                width: 6px;
                height: 6px;
                background: #1890ff;
                border-radius: 50%;
                margin-top: 8px;
                margin-right: 3px;
              "
            ></div>
            <div>正常</div>
          </div>
          <div style="display: flex" v-if="record.currentStatus == 1">
            <div
              style="
                width: 6px;
                height: 6px;
                background: #f5222d;
                border-radius: 50%;
                margin-top: 8px;
                margin-right: 3px;
              "
            ></div>
            <div>异常</div>
          </div>
          <div style="display: flex" v-if="record.currentStatus == 3">
            <div
              style="
                width: 6px;
                height: 6px;
                background: #22f525;
                border-radius: 50%;
                margin-top: 8px;
                margin-right: 3px;
              "
            ></div>
            <div>等待验证</div>
          </div>
        </span>
        <span slot="monitorStatus" slot-scope="text, record">
          <div style="display: flex" v-if="record.monitorStatus == 0">
            <div
              style="
                width: 6px;
                height: 6px;
                background: #1890ff;
                border-radius: 50%;
                margin-top: 8px;
                margin-right: 3px;
              "
            ></div>
            <div>正常</div>
          </div>
          <div style="display: flex" v-if="record.monitorStatus == 1">
            <div
              style="
                width: 6px;
                height: 6px;
                background: #ffa720;
                border-radius: 50%;
                margin-top: 8px;
                margin-right: 3px;
              "
            ></div>
            <div>停止监控</div>
          </div>
        </span>
        <span slot="allotStatus" slot-scope="text, record">{{
          returnAllotStatus(record.allotStatus)
        }}</span>
        <span slot="monitorHz" slot-scope="text, record">{{
          text ? (record.currentStatus == 2 ? '--' : text + '天') : '--'
        }}</span>
        <span slot="groupId" slot-scope="text, record">{{ returnGroupId(record.groupId) }}</span>
        <span slot="groupMemberId" slot-scope="text, record">{{
          returnGroupMemberId(record.groupMemberId)
        }}</span>
        <span slot="userGroupDto.groupName" slot-scope="text, record">{{
          text ? text : '--'
        }}</span>
        <span slot="userGroupMemberDto.userDto.userName" slot-scope="text, record">{{
          text ? text : '--'
        }}</span>
        <div slot="action" slot-scope="text, record">
          <a href="javascript:;" @click="handleGroupPz(record)" style="margin-right: 8px">
            监控配置
          </a>
          <a href="javascript:;" @click="handleEdit(record)"> 站点配置 </a>
        </div>
      </a-table>
    </div>
    <a-drawer
      :title="formModel == null ? '新增用户' : '修改用户'"
      width="600"
      :closable="true"
      :visible="visible"
      @close="visible = false"
    >
      <Form ref="form" v-if="visible" @refresh="handleRefresh" :formModel="formModel" />
    </a-drawer>
    <ModelZT
      ref="ModelZT"
      :selectedRowKeys="selectedRowKeys"
      :total="pagination.total"
      @reload="
        () => {
          selectedRowKeys = []
          this.getTableList()
        }
      "
    ></ModelZT>
    <modelPZ
      ref="modelPZ"
      :total="pagination.total"
      :selectedRowKeys="selectedRowKeys"
      @reload="
        () => {
          selectedRowKeys = []
          this.getTableList()
        }
      "
    ></modelPZ>
  </div>
</template>

<script>
import { queryUserApi, deleteUserApi } from '@/api/System/User'
import { querySpiderClassInfoApi } from '@/api/Site/Type'
import { configInfo } from '@/api/Monitor/abnormal'
import { info } from '@/api/System/User'
import ModelZT from './modelZT.vue'
import modelPZ from './modelPZ.vue'
import Clipboard from 'clipboard'
import { message } from 'ant-design-vue'
// import moment from 'moment'
import Form from './Form.vue'
export default {
  data() {
    return {
      tableDensity: 'middle',
      loading: false,
      visible: false,
      spiderClassOptions: [],
      selectedRowKeys: [],
      search: {
        groupId: '全部',
        degreeImport: '全部',
        currentStatus: '全部',
        allotStatus: '全部',
        siteType: '全部',
        monitorStatus: '全部'
      },
      columns: [
        {
          width: 60,
          title: '序号',
          align: 'left',
          show: true,
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '站点Id',
          dataIndex: 'siteId',
          show: true,
          align: 'left',
          scopedSlots: { customRender: 'siteId' }
        },
        {
          title: '站点名称',
          dataIndex: 'siteName',
          show: true,
          align: 'left',
          scopedSlots: { customRender: 'siteName' }
        },
        {
          title: '站点类型',
          dataIndex: 'siteType',
          show: true,
          align: 'left',
          scopedSlots: { customRender: 'siteType' }
        },
        {
          title: '重要程度',
          dataIndex: 'degreeImport',
          show: true,
          align: 'left',
          scopedSlots: { customRender: 'degreeImport' }
        },
        {
          title: '当前状态',
          dataIndex: 'currentStatus',
          show: true,
          align: 'left',
          scopedSlots: { customRender: 'currentStatus' }
        },
        {
          title: '监控状态',
          dataIndex: 'monitorStatus',
          show: true,
          align: 'left',
          scopedSlots: { customRender: 'monitorStatus' }
        },
        {
          title: '分配状态',
          dataIndex: 'allotStatus',
          show: true,
          align: 'left',
          scopedSlots: { customRender: 'allotStatus' }
        },
        {
          title: '负责团队',
          dataIndex: 'userGroupDto.groupName',
          show: true,
          align: 'left',
          scopedSlots: { customRender: 'userGroupDto.groupName' }
        },
        {
          title: '负责人员',
          dataIndex: 'userGroupMemberDto.userDto.userName',
          show: true,
          align: 'left',
          scopedSlots: { customRender: 'userGroupMemberDto.userDto.userName' }
        },
        {
          title: '监控天数',
          dataIndex: 'monitorHz',
          show: true,
          align: 'left',
          scopedSlots: { customRender: 'monitorHz' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          show: true,
          align: 'left'
        }
      ],
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        showTotal: (total) => `共 ${total} 条`,
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        size: 'default'
      },
      sorter: {},
      formModel: null,
      peopleGroup: [],
      dataGroup: [],
      peopleGroupCopy: []
    }
  },
  created() {
    this.getTableList()
    this.querySpiderClassInfo()

    this.leftData()
  },
  computed: {
    showColumns() {
      return this.columns.filter((item) => item.show)
    }
  },
  methods: {
    returnSiteName(item) {
      if (item) {
        if (item.length > 20) {
          const str = item.substring(0, 21)
          return str + '...'
        } else {
          return item
        }
      } else {
        return ''
      }
    },
    openWindow(record) {
      window.open('/#/site_info?' + 'spiderId=' + record.siteId + '&type=' + record.siteType)
    },
    selectValue(value) {
      if (value === '全部') {
        this.peopleGroup = this.peopleGroupCopy
      }
      this.search.groupMemberId = undefined
      this.dataGroup.forEach((element) => {
        if (element.id === value) {
          if (element.userGroupMemberDtoList) {
            this.peopleGroup = element.userGroupMemberDtoList
          } else {
            this.peopleGroup = []
          }
        }
      })
    },
    leftData() {
      info().then((res) => {
        this.dataGroup = res.data
        this.dataGroupCopy = res.data
        let people = []
        this.dataGroup.forEach((element) => {
          if (element.userGroupMemberDtoList) {
            element.userGroupMemberDtoList.forEach((element) => {
              people.push(element)
            })
          }
        })
        this.peopleGroup = people
        this.peopleGroupCopy = people
      })
    },
    returnSiteType(data) {
      let a = ''
      this.spiderClassOptions.forEach((element) => {
        if (element.type === data) {
          a = element.spiderClassName
        }
      })
      return a
    },
    returnAllotStatus(data) {
      switch (data) {
        case 0:
          return '待分配'
        case 1:
          return '已分配'

        default:
          break
      }
    },
    returnDegreeImport(data) {
      // let list = {(0:未知，1：一般，2：重要，3：非常重要}
      switch (data) {
        case 0:
          return '未知'
        case 1:
          return '一般'
        case 2:
          return '重要'
        case 3:
          return '非常重要'

        default:
          break
      }
    },
    returnGroupId(data) {
      let a = ''
      this.dataGroupCopy.forEach((element) => {
        if (element.id === data) {
          a = element.groupName
        }
      })
      return a
    },
    returnGroupMemberId(data) {
      let a = ''
      this.peopleGroupCopy.forEach((element) => {
        if (element.userId === data) {
          a = element.userDto.userName
        }
      })
      if (a === '') {
        a = '--'
      }
      return a
    },
    // 复制成功时的回调函数
    onCopy(e) {
      this.$message.success('已复制')
    },
    // 复制失败时的回调函数
    onCopyError(e) {
      this.$message.error('复制失败')
    },
    copy: function () {
      var _this = this
      var clipboard = new Clipboard('#copy_text')

      clipboard.on('success', (e) => {
        message.success('复制成功')
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', (e) => {
        // 不支持复制
        Message({
          message: '该浏览器不支持自动复制',
          type: 'warning'
        })
        // 释放内存
        clipboard.destroy()
      })
    },
    handleGroup(record) {
      this.$refs.ModelZT.showModel()
    },
    handleGroupPz(record) {
      this.$refs.modelPZ.showModel(record)
    },
    handleGroupPzS(record) {
      this.$refs.modelPZ.showModelForPL(record)
    },
    async querySpiderClassInfo() {
      let res = await querySpiderClassInfoApi()
      let { code, msg, data } = res
      if (code == '200') {
        this.spiderClassOptions = data
      } else {
        this.$message.error(msg)
      }
    },
    reset() {
      this.search = {
        groupId: '全部',
        degreeImport: '全部',
        currentStatus: '全部',
        allotStatus: '全部',
        siteType: '全部',
        monitorStatus: '全部'
      }
      this.getTableList()
    },
    handleAdd() {
      this.formModel = null
      this.visible = true
    },

    handleEdit(record) {
      // window.open('/#/site_create_form?' + 'spiderId=' + record.siteId + '&type=' + record.siteType)
      this.$router.push({
        name: 'site_create_form',
        query: { spiderId: record.siteId, type: record.siteType || 'news' }
      })

      // this.$router.push({
      //   path: 'monitor_gathererInfo'
      //   // query: {
      //   //   subjectId: record.subjectId,
      //   //   subjectName: record.subjectName,
      //   //   type: record.type
      //   // }
      // })
      // this.formModel = record
      // this.visible = true
    },

    handleSearch() {
      this.pagination.current = 1
      this.selectedRowKeys = []
      this.getTableList()
    },

    handleRefresh() {
      this.pagination.current = 1
      this.selectedRowKeys = []
      this.visible = false
      this.getTableList()
    },

    handleReset() {
      this.search.userName = ''
      this.search.phone = ''
      this.search.mail = ''
      this.handleSearch()
    },

    //根据id删除数据
    async handleDelete({ userId }) {
      const res = await deleteUserApi({ userId })
      const { code, msg } = res
      if (code == '200') {
        this.getTableList()
        this.$message.success(msg)
      } else {
        this.$message.error(msg)
      }
    },

    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination
      if (sorter.order) {
        this.sorter = {
          orderKey: sorter.field,
          isAsc: sorter.order == 'ascend' ? true : false
        }
      } else {
        this.sorter = {}
      }
      this.getTableList()
    },

    async getTableList() {
      let query = {
        pn: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.search
      }
      for (let i in query) {
        if (query[i] === '全部') {
          query[i] = undefined
        }
      }
      this.loading = true
      let res = await configInfo(query)
      this.loading = false
      let { code, msg, data, extra } = res
      if (code == '200') {
        this.dataSource = data
        this.pagination.total = extra.page.pageCount || 0
      } else {
        this.$message.error(msg)
      }
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    }
  },
  components: {
    Form,
    ModelZT,
    modelPZ
  }
}
</script>

<style lang="less" scoped>
.data-manage {
  padding: 16px;
  .search {
    padding: 20px 20px 0 20px;
    background: #fff;
    margin-bottom: 20px;
  }
  .table-wrap {
    margin-top: 16px;
    background: #fff;
    padding: 0 20px 0 20px;
  }
}
</style>
